export const ticketMock = {
  id: "500bL00000EOxjlQAD",
  number: "00193409",
  title: "Login issues with mobile app",
  order_number: null,
  product: "tiny",
  created_at: "2025-06-18T19:42:04.000+0000",
  updated_at: "2025-06-18T19:58:00.000+0000",
  status: "pendente",
  priority: "média",
  opened_by: "005Hr00000FJOBcIAP",
  discussion: [
    {
      id: "0D5bL00000Ix73ASAR",
      date: "2025-06-18T19:58:00.000Z",
      body: [
        {
          text: "Olá,\n\nObrigado por entrar em contato conosco. Sua solicitação, de número 00193409, foi recebida pelo nosso time de ERP. Em até 24h úteis, retomaremos o contato.\n\nVerifique em https://meusite.com/pedidos ou em www.exemplo.com.\n\nPara acrescentar um comentário ou uma nova informação, basta responder a esta mensagem.\n\nObrigado,\n\nTime de Atendimento de Olist ERP",
          type: "text",
        },
      ],
      attachments: [],
      sent_by: "support",
    },
  ],
  contact_email: "jhonathan.ballesteros+olistfilial05@olist.com",
  attachments: [],
  description:
    "I'm having trouble logging into the mobile app. When I enter my credentials, it shows a loading spinner but then returns to the login screen without any error message. This has been happening for the past 3 days.",
};
